<template>
  <m-scrollbar>
    <div class="grid">
      <div class="deposit-info grid-cell">
        <div class="info-message">
          <p> {{ $t('account.payments.deposit.system') }} </p>
          <br>
          <div class="payment-grid">
            <div class="payment-grid-title-cell">
              <span> {{ $t('account.payments.deposit.method') }} </span>
            </div>
            <div class="payment-grid-title-cell">
              <span> {{ $t('account.payments.deposit.min') }} </span>
            </div>
            <div class="payment-grid-title-cell-right">
              <span> {{ $t('account.payments.deposit.max') }} </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-piastrix method="piastrix" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.piastrix') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 1.0 RUR / 1.0 USD / 1.0 EUR </span>
            </div>
            <div class="payment-grid-cell-right-32">
              <span> 100000.0 RUR / 100000.0 USD / 100000.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-qiwi method="qiwi" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.qiwi') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 100.0 RUR / 0.05 USD / 0.5 EUR </span>
            </div>
            <div class="payment-grid-cell-right-32">
              <span> 250000.0 RUR / 3900.0 USD / 3400.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-payeer method="payeer" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.payeer') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 1.0 RUR / 0.01 USD / 0.01 EUR </span>
            </div>
            <div class="payment-grid-cell-right-32">
              <span> 500000.0 RUR / 10000.0 USD / 10000.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-pm method="pm" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.pm') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 0.01 USD / 0.01 EUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 10000.0 USD / 10000.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-beeline method="beeline" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.beeline') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 15000.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-mts method="mts" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.mts') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 14999.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-megafon method="megafon" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.megafon') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 15000.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-tele2 method="tele2" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.tele2') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 15000.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell-bottom-left">
              <payment-alfabank method="alfabank" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.alfabank') }} </p>
            </div>
            <div class="payment-grid-cell-bottom">
              <span> 1.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right-bottom">
              <span> 15000.0 RUR </span>
            </div>
          </div>
        </div>
      </div>
      <div class="deposit-form grid-cell">
        <div class="info-message">
          <p> {{ $t('account.payments.withdrawal.system') }} </p>
          <br>
          <div class="payment-grid">
            <div class="payment-grid-title-cell">
              <span> {{ $t('account.payments.deposit.method') }} </span>
            </div>
            <div class="payment-grid-title-cell">
              <span> {{ $t('account.payments.deposit.min') }} </span>
            </div>
            <div class="payment-grid-title-cell-right">
              <span> {{ $t('account.payments.deposit.max') }} </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-piastrix method="piastrix" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.piastrix') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 1.0 RUR / 1.0 USD / 1.0 EUR </span>
            </div>
            <div class="payment-grid-cell-right-32">
              <span> 100000.0 RUR / 100000.0 USD / 100000.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-qiwi method="qiwi" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.qiwi') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 100.0 RUR / 0.05 USD / 0.5 EUR </span>
            </div>
            <div class="payment-grid-cell-right-32">
              <span> 250000.0 RUR / 3900.0 USD / 3400.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-payeer method="payeer" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.payeer') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 1.0 RUR / 0.01 USD / 0.01 EUR </span>
            </div>
            <div class="payment-grid-cell-right-32">
              <span> 500000.0 RUR / 10000.0 USD / 10000.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-pm method="pm" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.pm') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 0.01 USD / 0.01 EUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 10000.0 USD / 10000.0 EUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-beeline method="beeline" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.beeline') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 15000.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-mts method="mts" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.mts') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 14999.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-megafon method="megafon" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.megafon') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 15000.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell">
              <payment-tele2 method="tele2" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.tele2') }} </p>
            </div>
            <div class="payment-grid-cell-65">
              <span> 10.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right">
              <span> 15000.0 RUR </span>
            </div>
          </div>
          <div class="payment-grid">
            <div class="payment-grid-cell-bottom-left">
              <payment-alfabank method="alfabank" :pixel-size="35" />
              <p> {{ $t('account.payments.deposit.alfabank') }} </p>
            </div>
            <div class="payment-grid-cell-bottom">
              <span> 1.0 RUR </span>
            </div>
            <div class="payment-grid-cell-right-bottom">
              <span> 15000.0 RUR </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </m-scrollbar>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import MBoard from '@/components/MBoard'
import ColorButton from '@/components/buttons/ColorButton'
import PaymentAlfabank from '@/components/icons/PaymentAlfabank'
import PaymentBeeline from '@/components/icons/PaymentBeeline'
import PaymentMts from '@/components/icons/PaymentMts'
import PaymentMegafon from '@/components/icons/PaymentMegafon'
import PaymentPayeer from '@/components/icons/PaymentPayeer'
import PaymentPiastrix from '@/components/icons/PaymentPiastrix'
import PaymentPm from '@/components/icons/PaymentPm'
import PaymentQiwi from '@/components/icons/PaymentQiwi'
import PaymentTele2 from '@/components/icons/PaymentTele2'

export default {
  components: {
    MLayoutMask,
    MLayout,
    MScrollbar,
    MWidgetHead,
    MHideToggler,
    MBoard,
    ColorButton,
    PaymentAlfabank,
    PaymentBeeline,
    PaymentMts,
    PaymentMegafon,
    PaymentPayeer,
    PaymentPiastrix,
    PaymentPm,
    PaymentQiwi,
    PaymentTele2
  },
  data () {
    return {
      compactSidebar: false
    }
  }
}
</script>

<style scoped>
.board { border-radius: 5px; margin: 0 10px; }
.grid { display: flex; flex-wrap: wrap; padding: 15px 0; }
.grid-cell { width: 50%; }
.payment-grid { display: flex; flex-wrap: wrap; }
.payment-grid-cell { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 65px; }
.payment-grid-cell-65 { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 65px; line-height: 65px; }
.payment-grid-cell-32 { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 65px; line-height: 32px; }
.payment-grid-cell-bottom { width: 33.3%; border-left: 1px solid #007354; height: 65px; border-top: 1px solid #007354; border-bottom: 1px solid #007354; height: 65px; height: 65px; line-height: 65px; }
.payment-grid-cell-bottom-left { width: 33.3%; border-left: 1px solid #007354; height: 65px; border-top: 1px solid #007354; border-bottom: 1px solid #007354; height: 65px; height: 65px; line-height: 15px; }
.payment-grid-cell-right-bottom { width: 33.3%; border: 1px solid #007354; line-height: 63px; }
.payment-grid-cell-right { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 65px; border-right: 1px solid #007354; line-height: 65px; }
.payment-grid-cell-right-32 { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 65px; border-right: 1px solid #007354; line-height: 32px; }
.payment-grid-title-cell { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 20px; }
.payment-grid-title-cell-right { width: 33.3%; border-left: 1px solid #007354; border-top: 1px solid #007354; height: 20px; border-right: 1px solid #007354; }
.board-form-message { margin: 0 10px 10px; text-align: center; }
.form { width: 50%; }
.form-actions .color-button { left: 50%; margin-left: 5px; }

.deposit-info { border-bottom-left-radius: 5px; display: flex; overflow: hidden; position: relative; }
.deposit-form { padding-bottom: 10px; }
.deposit-form .payment-icon { margin: -1px 5px 0 0; }
.method-title { margin: 10px 0; }
.title { text-align: right; }

.info-message { margin: 0 1px; text-align: center; width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/payments/Payments.vue